<template>
    <div class="px-0">
        <v-container class="px-0 py-5" style="max-width: 100% !important">
            <v-card class="px-0 py-3 size">
                <v-row class="px-5 pt-5">
                    <v-col cols="12" align="center" justify="center">    
                        <h3 class="blue_accent--text text-uppercase">{{ $t('edit_warehouse.edit') }}</h3>
                    </v-col>
                </v-row>
                <v-card-text class="px-0">
                    <v-form ref="form" lazy-validation @submit.prevent="save">
                       <v-row class="px-5 py-0 my-0" justify="center" align="center">
                            <v-col cols="6" class="py-0">
                                <v-text-field class="py-0" v-model="warehouse.name" :label="$t('edit_warehouse.name')" :rules="rules_required"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="px-5 py-0 my-0" justify="center" align="center">
                            <v-col cols="6" class="py-0">
                                <v-autocomplete class="mt-0 py-0" v-model="warehouse.country" :loading="countries_load" :items="countries" :label="$t('edit_warehouse.country')" :rules="rules_required"></v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row class="px-5 py-0 my-0" justify="center" align="center">
                            <v-col cols="6" class="py-0">
                                <v-autocomplete class="mt-0 py-0" v-model="warehouse.state" :loading="states_load" :items="states" :label="$t('edit_warehouse.state')" :rules="rules_required"></v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row class="px-5 py-0 my-0" justify="center" align="center">
                            <v-col cols="6" class="py-0">
                                <v-text-field class="py-0" v-model="warehouse.municipality" :label="$t('create_warehouse.municipality')" :rules="rules_required"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="px-5 py-0 my-0" justify="center" align="center">
                            <v-col cols="6" class="py-0">
                                <v-text-field class="py-0" v-model="warehouse.neighborhood" :label="$t('edit_warehouse.neighborhood')" :rules="rules_required"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="px-5 py-0 my-0" justify="center" align="center">
                            <v-col cols="6" class="py-0">
                                <v-text-field class="py-0" v-model="warehouse.street" :label="$t('edit_warehouse.street')" :rules="rules_required"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="px-5 py-0 my-0" justify="center" align="center">
                            <v-col cols="2" class="py-0">
                                <v-text-field class="py-0" v-model="warehouse.zipcode" :label="$t('edit_warehouse.zip_code')" :rules="rules_required"></v-text-field>
                            </v-col>
                            <v-col cols="2" class="py-0">
                                <v-text-field class="py-0" v-model="warehouse.external_number" :label="$t('edit_warehouse.ext_number')" :rules="rules_required"></v-text-field>
                            </v-col>
                            <v-col cols="2" class="py-0">
                                <v-text-field class="py-0" v-model="warehouse.internal_number" :label="$t('edit_warehouse.int_number')"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="px-5 py-0 my-0" justify="center" align="center">
                            <v-col cols="6" class="py-0">
                                <v-checkbox class="mt-0" color="blue_accent" v-model="warehouse.picking_required" :label="$t('edit_warehouse.pickeo_required')" :rules="rules_required"></v-checkbox>
                            </v-col>
                        </v-row>
                        <v-row class="px-5 pt-1 mt-0" justify="center" align="center">
                            <v-col cols="6" align="start" justify="start">    
                                <h4 class="blue_accent--text text-uppercase">{{ $t('edit_warehouse.shipping_services') }}</h4>
                                <label>{{ $t('edit_warehouse.select_shipping_services') }}</label>
                            </v-col>
                        </v-row>
                        <v-row v-for="ss of warehouse.shipping_services" :key="ss.id" class="px-5 py-0 my-0" justify="center" align="center">
                            <v-col cols="6" class="py-0">
                                <v-checkbox class="mt-0" color="blue_accent" v-model="ss.work" :label="ss.name"></v-checkbox>
                            </v-col>
                        </v-row>
                    </v-form>
                    <v-row class="px-5 py-0 mt-1" justify="center">
                        <v-col cols="6">
                            <v-row>
                                <v-col cols="4" justify="start" align="start">
                                    <btn-delete :label="'edit_warehouse.disable'" @click="disable"></btn-delete>
                                </v-col>
                                <v-col cols="8" justify="end" align="end">
                                    <btn-cancel :label="'edit_warehouse.cancel'" @click="cancel"></btn-cancel>
                                    <btn-pf :label="'edit_warehouse.save'" @click="save"></btn-pf>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>    
        </v-container>        
        <v-snackbar v-model="snackbar.visible" :timeout="4000" :color="snackbar.color" style="text-align: center; color: var(--v-accent-base);">{{ snackbar.text }}</v-snackbar>
    </div>
</template>
<script>
export default {
    computed: {
        rules_required(){return [v => !!v || this.$t('create_appointment.validations.required_field')]}, 
    },
    data(){
        return {
            id: this.$route.params.id,
            snackbar: {
                visible: false,
                color: 'primary',
                text: ''
            },
            countries: [],
            states: [],
            warehouse: {
                country: '',
                state: '',
                name: '',
                neighborhood: '',
                municipality: '',
                street: '',
                zipcode: '',
                external_number: '',
                internal_number: '',
                shipping_services: [],
                picking_required: false
            },
            countries_load: false,
            states_load: false,
        }
    },
    mounted(){
        this.index();
        this.$store.state.module = "headers.edit_warehouse";
    },
    methods: {
        index(){
            this.countries_load = true;
            this.$http.get("https://locations.intech.mx/api/getCountries", {})
            .then((response) => {
                this.countries = response.data
                this.countries_load = false;
            }).finally(() => {
                this.countries_load = false;
            });

            // Get current warehouse
            this.$store.state.loaderProps.visible = true;
            const lsToken = localStorage.getItem("access_token");
            this.$http.get(this.$store.state.chronosApi + 'warehouses/' + this.id, {headers: {Authorization: lsToken}})
            .then((response) => {
                this.warehouse = response.data.data.attributes;
                // Get current shipping services
                this.$http.get(this.$store.state.chronosApi + 'shipping_services/', {headers: {Authorization: lsToken}})
                .then((response1) => {
                    var wss = [];
                    response1.data.forEach(x => {
                        var exist = false;
                        this.warehouse.shipping_services.forEach(y => {
                            if(y.attributes.name == x.name) {
                                wss.push({name: x.name, id:x.id, work: true});
                                exist= true
                                return;
                            }
                        })
                        if(exist == false) wss.push({name: x.name, id:x.id, work: false});                
                    })
                    this.warehouse.shipping_services = wss;
                }).catch((err) => {
                    console.log(err);
                })
            }).catch((err) => {
                console.log(err);
            }).finally(() => {
                this.$store.state.loaderProps.visible = false;
            })
        },
        save(){
            delete this.warehouse.id;
            this.$store.state.loaderProps.visible = true;
            const lsToken = localStorage.getItem("access_token");
            this.$http.put(this.$store.state.chronosApi + 'warehouses/' + this.id, this.warehouse, {headers: {Authorization: lsToken}})
            .then((response) => {
                if(response.status == 200){
                    this.snackbar = {
                        visible: true,
                        color: 'success2',
                        text: this.$t('edit_warehouse.responses.success')
                    }
                    this.$router.push({ name: "WarehousesIndex" });  
                }
            }).catch((err) => {
                console.log(err);
            }).finally(() => {
                this.$store.state.loaderProps.visible = false;
            })
        },
        cancel(){
            this.$router.go(-1);
        },
        disable(){
            console.log(this.warehouse)
            this.$store.state.loaderProps.visible = true;
            const lsToken = localStorage.getItem("access_token");
            this.$http.delete(this.$store.state.chronosApi + 'disable-warehouse?id=' + this.id, {headers: {Authorization: lsToken}})
            .then((response) => {
                if(response.status == 200){
                    this.snackbar = {
                        visible: true,
                        color: 'success2',
                        text: this.$t('edit_warehouse.responses.success')
                    }
                    this.$router.push({ name: "WarehousesIndex" });  
                }
            }).catch((err) => {
                console.log(err);
            }).finally(() => {
                this.$store.state.loaderProps.visible = false;
            })
        }
    },
    watch:{
        "warehouse.country": function(){
            this.states = [];
            this.states_load = true;
            this.$http.get("https://locations.intech.mx/api/getStates/"+this.warehouse.country, {})
            .then((response) => {
                if(response.status === 200){
                    this.states = response.data
                    this.states_load = false;
                }
            }).finally(() => {
                this.states_load = false;
            });
        },
    }
}
</script>

<style lang="css">
</style>